import axios from 'axios'
import { useContext, useState } from 'react'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useHistory } from 'react-router'
import { useAuthentication } from '../Authentication/useAuthentication'
import { useDownload } from '../../hooks/Download/useDownload'
import urlSearchParams from '../../components/urlSearchParams'
import { BeatPlanContext } from '../../context api/BeatPlan/BeatPlanContext'

export const UseBeatPlan = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history= useHistory();
  const { addNewBeatPlan, getAllBeatPlans, getBeatPlan, deleteBeatPlan, beatPlans} = useContext(BeatPlanContext)
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();
  const [loading, setLoading] = useState(false)
  // const [pdfCsvData, setPdfCsvData] = useState([])

  //CATEGORY

  const getAllBeatPlan = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_BEAT_PLANS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong in fetching  !', error)
        }
        // calling the context to set the state of all temp orders
        // console.log(getAllBeatPlans)
        getPdfCsvData('GET_ALL_BEAT_PLANS', {...dto, download : true})
        getAllBeatPlans(data.data); 
        setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })

        //  false, loading: false })
        
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        } 
      })
  }

  const addBeatPlan = async (dto) => {
    setLoading(true)
    // await fileUpload({file:dto.image})
    console.log("adding beat plan")
    await axios
      .post(API.ADD_BEAT_PLAN, dto, header)
      .then(({ status, data }) => {
        console.log('BEAT ADD : ', data, status)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }else{
          toastMessage('Beat Plan Added Successfully', success)
          addNewBeatPlan(data.data)
          history.push(ROUTES.BEAT_PLANS)  
        }
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        // console.log(JSON.stringify(err))
        return toastMessage("something went wrong", error)
      })
  }

  const BulkUploadBeatPlan = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD_BEAT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewBeatPlan)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const editBeatPlan = async (dto, id)=>{
    setLoading(true)
    await axios
      .put(API.EDIT_BEAT_PLAN(id), dto, header)
      .then(({ status, data }) => {
        console.log("header", header)
        console.log('DATA : ', data)
        setLoading(false)
        if (status == 201) {
          history.push(ROUTES.BEAT_PLANS)
        }
        else{
          console.log(status)
          return toastMessage('Something Went Wrong !', error)

        }

        // setTmpOrders(data.category)

        //  false, loading: false })
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          console.log(err.responsea)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteMany = async (dto)=>{
    setLoading(true)
    // await fileUpload({file:dto.image})
    await axios
      .post(API.DELETE_BEAT_PLANS, dto, header)
      .then(({ status, data }) => {
        console.log("header", header)
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        toastMessage('Beat Plans Deleted Successfully', success)
        setLoading(true);
        getAllBeatPlan();
        history.push(ROUTES.ADD_TMP_ORDER)
        console.log(data.data);
        // setLoading(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          return toastMessage(err, error)
        }
      })
  }
  
  const getSingleBeatPlan = (id) => {
    let obj = {}
    beatPlans.forEach(beatPlan =>{
      if(beatPlan._id === id){
         obj = beatPlan;
        }
    })
    return obj;
  }


  return {
    getAllBeatPlan,
    addBeatPlan,
    BulkUploadBeatPlan,
    editBeatPlan,
    deleteMany,
    getSingleBeatPlan,
    loading,
    beatPlans,
    pdfCsvData,
  }
}
